export default __webpack_public_path__ + "static/media/coming-soon-img.7256abdf.png";